import { motion } from "framer-motion";
import { ArrowRight, EyeOff, Handshake } from "lucide-react";
import { Button } from "../ui/button";
import VideoHero from "../landing/VideoHero";

export default function AgenciesHero() {
  return (
    <section
      className="relative min-h-[92vh] flex items-center overflow-hidden"
      data-testid="agencies-hero"
    >
      <div className="absolute inset-0 z-0">
        <VideoHero />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/65 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 lg:py-36 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6">
            <Handshake className="w-4 h-4 text-blue-300" />
            <span className="text-sm text-white font-body font-medium">
              Para agencias de marketing y comunicación
            </span>
          </div>

          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white leading-[1.08] mb-6 drop-shadow-2xl">
            Ayuda a tus clientes a generar
            <span className="block bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
              más autoridad y oportunidades
            </span>
            de venta con su VideoPodcast
          </h1>

          <p className="font-body text-lg lg:text-xl text-slate-200 max-w-2xl mb-10 leading-relaxed drop-shadow-lg">
            Hoy no vende el que más anuncios pone, sino el que más confianza genera. Tú diseñas la
            estrategia y mantienes la relación con tu cliente;{" "}
            <strong className="text-white">nosotros nos encargamos de toda la producción</strong> del
            videopodcast en white label, con tu marca y sin aparecer nunca.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a href="#solicitar-propuesta">
              <Button
                className="bg-gradient-to-r from-galvani-blue to-galvani-purple hover:opacity-90 text-white font-body font-semibold px-8 py-4 text-base rounded-full transition-all duration-300 hover:scale-105 shadow-xl shadow-blue-500/40 w-full sm:w-auto"
                data-testid="agencies-hero-cta"
              >
                Quiero más información
                <ArrowRight size={16} className="ml-2" />
              </Button>
            </a>
            <a href="#oportunidad">
              <Button
                variant="outline"
                className="border-white/40 bg-white/5 backdrop-blur-md text-white hover:bg-white/15 font-body font-semibold px-8 py-4 text-base rounded-full w-full sm:w-auto"
                data-testid="agencies-hero-secondary"
              >
                Todavía no lo vendo, cuéntame
              </Button>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-slate-200">
            <div className="flex items-center gap-2">
              <EyeOff className="w-4 h-4 text-blue-300" />
              <span>100% white label</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              <span>Estudio propio en Madrid o en las instalaciones de tu cliente</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              <span>Comunidad de Madrid y 70 km alrededor</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
